var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.704 11.853-8.637-.8-3.431-7.968a.692.692 0 0 0-1.272 0l-3.43 7.967-8.638.801a.692.692 0 0 0-.393 1.21l6.517 5.725-1.907 8.462a.692.692 0 0 0 1.028.747L16 23.568l7.459 4.43a.692.692 0 0 0 1.028-.748l-1.907-8.462 6.517-5.726a.692.692 0 0 0-.393-1.209z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.636 3.085a.692.692 0 0 0-1.272 0l-3.43 7.967-8.638.801a.692.692 0 0 0-.393 1.21l6.517 5.725-1.907 8.462a.692.692 0 0 0 1.028.747l1.665-.988c.23-9.485 4.637-16.164 8.126-19.985l-1.696-3.939z",
    fill: "#FFD164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.637b05c4.svg";
export { ForwardRef as ReactComponent };